import { Component, OnInit, Input, OnDestroy, NgZone, ViewChild } from '@angular/core';
import { SubSink } from 'subsink';
import { ProfileService } from '@data/services/profile.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { EncryptService } from '@core/services/encrypt.service';
import { encryptionKey } from '@shared/appConfig';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { SelectAccountComponent } from '../../shared/components/dialogs/select-account/select-account.component';

@Component({
  selector: 'app-header-layout',
  templateUrl: './header-layout.component.html',
  styleUrls: ['./header-layout.component.scss']
})
export class HeaderLayoutComponent implements OnInit, OnDestroy {
  @Input() UserDetails;
  @ViewChild(SelectAccountComponent, { static: false }) child;
  private subs = new SubSink();
  profilePic = '';
  userLoggedIn = false;
  currentUser;
  session;
  env: any = environment;
  keyCloakObj: any;
  isMissionaryUser:boolean=false;
  isFinanceUser:boolean=false;
  isSuperAdmin: boolean= false;
  isLoading: boolean = false;

  constructor(private profile: ProfileService,
    private localStorageService: LocalStorageService,
    private ngZone: NgZone, private encryptService: EncryptService,
    public route: Router,
    protected readonly keycloak: KeycloakService
  ) {
    this.localStorageService = new LocalStorageService(this.profile);
  }

  ngOnInit() {
    this.session = this.currentUser = JSON.parse(localStorage.getItem('session'));
    let superAdminEmailIds = environment.superAdminEmailId.toLowerCase().split(',');
    if (this.session != null) {
      this.userLoggedIn = true;
      if (typeof this.session.thumbnailURL != 'undefined' && this.session.thumbnailURL != '') {
        this.profilePic = JSON.stringify(this.session.thumbnailURL);
      } else {
        this.profilePic = "assets/img/Default_Profile_Img.png";
      }
      if (typeof this.currentUser.email != 'undefined' && this.currentUser.email != '') {       
        if (superAdminEmailIds.includes(this.currentUser.email.toLowerCase())) {
          this.isSuperAdmin = true;
        }
      }
    }
    this.isMissionaryUser = JSON.parse(localStorage.getItem('isMissionaryUser'));
    this.isFinanceUser = JSON.parse(localStorage.getItem('isFinanceUser'));
    this.subs.add(this.profile.changeUserEvent.subscribe((result: any) => {
      if (result.AccountId) {
        this.ngZone.run(() => {
          if (typeof result.thumbnailURL != 'undefined') {
            this.profilePic = result.thumbnailURL;
          }
          if (typeof result.Email != 'undefined') {
            if (superAdminEmailIds.includes(result.Email.toLowerCase())) {
              this.isSuperAdmin = true;
            }
          }
          this.userLoggedIn = true;
          if (!this.profilePic) {
            this.profilePic = "assets/img/Default_Profile_Img.png";
          }
          this.isMissionaryUser = JSON.parse(localStorage.getItem('isMissionaryUser'));
          this.isFinanceUser = JSON.parse(localStorage.getItem('isFinanceUser'));
        });
        this.userLoggedIn = true;
      }
    }));
  }

  logout() {
    // this.common.loading = true;
    this.logoutUser();
  }

  public async logoutUser() {
    localStorage.removeItem('token');
    localStorage.removeItem('profile');
    localStorage.removeItem('session');
    localStorage.removeItem('missionaryGAUId');
    localStorage.removeItem('isMissionaryUser');
    localStorage.removeItem('isFinanceUser');
    localStorage.removeItem('isHQUser');
    localStorage.removeItem('isGAUEditor');
    localStorage.removeItem('loginProvider');
    localStorage.removeItem('userId');
    localStorage.removeItem('selectedAccount');
    var sourceApp = localStorage.getItem('sourceApp');
    localStorage.clear();
    localStorage.setItem('sourceApp',sourceApp);
    this.profile.logout();
    await this.keycloak.logout(window.location.origin + '')
      .then((response) => {
        console.log('response', response);
      })
      .catch(() => {
        console.log('Failed to logout user');
      });
  }

  redirectUserToLogin() {
    if (!this.session) {
      const redirectUrl = this.env.eventsAwanaUrl;
      const encrypted = this.encryptService.set(encryptionKey, redirectUrl);
      window.location.href = this.env.myAwanaUrl + 'login?route_url=' + encrypted;
    }
  }

  routeToURL(url) {
    window.open(
      url
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  public async getLogin() {
    await this.keycloak.login({
         redirectUri: window.location.origin,
    })
    .catch(
         function(err) {
          console.log('err', err);
    });
  }

    /**
  * @description Identify any event in Filter component and process the values selected in Filter
  */
     receiveMessage($event) {
      if (this.child.status !== 'Completed') {
        this.isLoading=true;        
      } else {
        this.isLoading=false;
        this.profile.profileUpdate();
      }      
    }

  redirectUser(route){
    this.route.navigate(['manageRouting'], { queryParams: { type: route } });
  }
}
